<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload = "handleReload"
                     @edit = "handleEdit"
                     @review="handleReview"
                     btn_copy
                     btn_review
        >
            <div class="pull-right d-flex" style="padding-top: 2px;">
                <one-file-upload :upload-url="modelImportUrl" @reload="handleReload" >
                    <el-button size="medium" type="success" class="mr-2"
                               icon="el-icon-upload2">{{('导入Excel')}}
                    </el-button>
                </one-file-upload>
                <el-button size="medium" @click="goDownload" type="danger"
                           icon="el-icon-download">{{('下载样本')}}
                </el-button>
            </div>

        </front-table>
        <!--编辑界面-->
        <edit-dialog :edit_mode="edit_mode" :model="model" :single="single" :fields="fields" dual
                     @success="handleSuccess" @cancel="handleCancel">

        </edit-dialog>
        <log-view :single="single" :view_mode="view_mode" @cancel="view_mode = false"></log-view>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import EditDialog from "../components/edit-dialog";
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import OneFileUpload from "../components/common-file-upload";
    import LogView from "@/components/log-view.vue";

    export default {
        mixins:[FrontMixins],

        name: "admin-xjtlu-user",
        components: {LogView, FrontTable, EditDialog,OneFileUpload},
        created() {
            this.model = 'Admin.XjtluUser';
        },
        methods:{
            goDownload(){
                window.open('/assets/files/PT&XJ_202209061111.xlsx');
            },
            handleReview(id) {
                let vm = this;
                vm.view_mode = 0;
                this.$api(this.model + '.Review', {id: id, review: true}, true).then(res => {
                    vm.single = res.data.data;
                    vm.view_mode = 1;
                });
            },
        },
        computed:{
            modelImportUrl() {
                return this.$apiUrl(this.model + '.Import');
            },
        }
    }

</script>

<style lang="scss">

</style>
